import { styled } from "styled-components";
import { breakpoints, fonts, media } from "../../components/common/mixins";

export const SubTitle = styled.p`
  ${fonts.normalText()};
  margin: 0;
  padding-top: 4px;
  line-height: normal;

  ${media.below(breakpoints.tablet)} {
    padding-top: 2px;
  }
`;
